import React from 'react'
import t from '../../translations/i18n'

export default function About () {
  return (
    <>
      <section id="about" className="about">
        <div className="container">
          <div className="row justify-content-between">
            <div className="col-lg-5 d-flex align-items-center justify-content-center about-img">
              <img src={t('sections.about_img')} className="img-fluid" alt="" data-aos="zoom-in" />
            </div>
            <div className="col-lg-6 pt-5 pt-lg-0">
              <h3 data-aos="fade-up">{t('sections.about_tittle_one')}</h3>
              <p data-aos="fade-up" data-aos-delay="100">
                {t('sections.about_subtittle_one')}
              </p>
              <div className="row">
                <div className="col-md-6" data-aos="fade-up" data-aos-delay="100">
                  <i className="bx bx-receipt"></i>
                  <h4>{t('sections.about_tittle_two')}</h4>
                  <p>{t('sections.about_subtittle_two')}</p>
                </div>
                <div className="col-md-6" data-aos="fade-up" data-aos-delay="200">
                  <i className="bx bx-cube-alt"></i>
                  <h4>{t('sections.about_tittle_three')}</h4>
                  <p>{t('sections.about_subtittle_three')}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
